module.exports = __webpack_public_path__ + "img/JourneyCategoryScreenshot-1250h.7cb6b961.webp";